<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
  position: {
    type: String,
    default: 'auto-right',
    validator: (value) => {
      return ['auto-right', 'auto-left', 'bottom-left', 'bottom-right', 'top-left', 'top-right'].includes(value);
    },
  },
  rect: {
    type: DOMRect,
    default: null
  },
  hasFooter: {
    type: Boolean
  },
  hasBorder: {
    type: Boolean,
    default: false
  }
});
const dropdown = ref(null);

watch(dropdown, () => {
  const { position, rect, hasFooter } = props;
  if (dropdown.value) {
    switch(position) {
      case 'bottom-left':
        dropdown.value.style.top = '100%';
        dropdown.value.style.left = '0';
        break;
      case 'bottom-right':
        dropdown.value.style.top = 'calc(100% + 5px)';
        dropdown.value.style.right = '0';
        break;
      case 'top-left':
        dropdown.value.style.bottom = 'calc(100% + 5px)';
        dropdown.value.style.left = '0';
        break;
      case 'top-right':
        dropdown.value.style.bottom = 'calc(100% + 5px)';
        dropdown.value.style.right = '0';
        break;
      default:
        if (rect) {
          const dropdownHeight = dropdown.value.offsetHeight;
          dropdown.value.style.right = '0';
          if (position === 'auto-left') {
            dropdown.value.style.removeProperty('right');
            dropdown.value.style.left = '0';
          }
          // Insure the dropdown is visible within the viewport
          // When there is not enough space to the bottom, show the dropdown on top
          // Morevoer add the footer height on top of it if the page has a footer
          if ((window.innerHeight - rect.bottom - (hasFooter ? 80 : 0)) - dropdownHeight - 5 < 0) {
            dropdown.value.style.bottom = 'calc(100% + 5px)';
          } else {
            dropdown.value.style.top = 'calc(100% + 5px)';
          }
        }
    }
  }
}, {
  flush: 'post'
});
</script>

<template>
  <div 
    ref="dropdown" 
    v-if="isVisible" 
    :class="{'dropdown__box': true, 'has-border': hasBorder}"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.dropdown__box {
  position: absolute;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 9999;

  &.has-border {
    border-radius: 4px;
    border: 1px solid var(--ZZ_Old-ZZ_Outline-Gray, #79747E);
    background: #FFF;

    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
  }
}
</style>
